import type React from "react";
import type { IRecentItem } from "../types";
import { ItemIconChain } from "@similarweb/ui-components";
import { BottomIconContainer, TopIconContainer } from "app/components/DiverseItemIcon/styledComponents";
import { StyledIconWrapper } from "./styledComponents";

interface BinaryIconProps {
    mainItem: IRecentItem;
    secondaryItem: IRecentItem;
}

export const BinaryIcon: React.FC<BinaryIconProps> = (props) => {
    return (
        <StyledIconWrapper>
            <TopIconContainer>
                <ItemIconChain
                    icons={[props.mainItem.icon]}
                    size={20}
                    maxIconChain={1}
                />
            </TopIconContainer>
            <BottomIconContainer>
                <ItemIconChain
                    icons={[props.secondaryItem.icon]}
                    size={20}
                    maxIconChain={1}
                />
            </BottomIconContainer>
        </StyledIconWrapper>
    );
};
